<template>
  <div v-if="showReferral && !isReferralRender && !referralCode">
    <b-modal
        id="accessCode-pop-agent"
        centered
        v-model="accessShow"
        no-close-on-backdrop
        no-close-on-esc
    >
      <template #modal-header>
        <div class="popUp-header">
          <h4> Referral Code</h4>
        </div>
      </template>
      <b-container fluid>
        <div>
          <div class="form-group mb-3">
            <label>Enter Referral Code</label>
            <input
                type="text"
                @hide="onModalHide"
                v-model="referralAccessCode"
                @input="$v.referralAccessCode.$touch();"
                :class="{
                'form-control is-invalid':
                  $v.referralAccessCode.$error || repErrorFlag,
              }"
                class="custom-input"
                placeholder="Enter Referral Code e.g. abcd121244"
            />
            <div
                class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.referralAccessCode.required && $v.referralAccessCode.$error"
            >
              Field is required
            </div>
            <div class="form-group__message text-left ml-3 mt-2" v-if="$v.referralAccessCode.required && $v.referralAccessCode.$invalid">
              Enter valid referral code
            </div>
          </div>
          <div class="form-group">
            <button class="univ-btn" @click="checkRepEnrollmentCode()">
              Submit
            </button>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import store from "../store";
import {checkReferralCode} from "../utils/validators";

export default {
  name: "ReferalCode",
  data () {
    return {
      referralAccessCode: null,
      repErrorFlag: false,
      accessShow: true
    }
  },
  computed: {
    showReferral () {
      return this.$store?.getters?.showReferral
    },
    isReferralRender () {
      return this.$store?.getters?.isReferralRender
    },
    referralCode () {
      return this.$store?.getters?.referralCode
    }
  },
  validations: {
    referralAccessCode: {
      required,
      checkReferralCode
    }
  },
  methods: {
    checkRepEnrollmentCode() {
      let app = this;
      app.$v.referralAccessCode.$touch();
      if (app.$v.referralAccessCode.$invalid) {
        return false;
      } else {
        const normalizedCode = (app.referralAccessCode || '').trim().toUpperCase()
        store.dispatch('isReferralRender', true)
        store.dispatch('referralCode', normalizedCode)
        app.accessShow = false
      }
    },
    onModalHide() {
      let app = this;
      app.accessShow = false
      store.dispatch('isReferralRender', true)
    }
  }
}
</script>

<style scoped>

</style>